import * as Sentry from "@sentry/react";

// Frontend error monitoring. No-op unless REACT_APP_SENTRY_DSN is set, so dev /
// preview builds without a DSN ship nothing. Errors-only (no performance
// tracing, no Session Replay) to keep it lightweight and GDPR-friendly —
// `sendDefaultPii: false` means no IP / user data is attached by default.
const DSN = process.env.REACT_APP_SENTRY_DSN || "";
const PRODUCTION_HOSTNAME = "ai.fped.org";

// Errors that are not ours to fix. Exported so a test can hold each entry to a
// real event, and hold our own code to NOT matching.
export const IGNORE_ERRORS = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications.",
  "Non-Error promise rejection captured",
  // Facebook's in-app browser on Android injects its own scripts into every
  // page it opens. When the visitor leaves the page, those scripts post a
  // message to the Java side of the app after Android has already torn it
  // down. Every frame in the trace is theirs (`iabjs://…`); Sentry only
  // catches it because it wraps `addEventListener` for the whole page.
  "Java object is gone",
];

// Scripts injected by in-app browsers rather than served by us. Matched
// against the frames of the stack trace, so an error that starts in one of
// them is dropped whatever its message says next month.
export const DENY_URLS = [
  /^iabjs:\/\//i,
];

export function initSentry() {
  if (!DSN) return;

  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  const environment =
    process.env.REACT_APP_SENTRY_ENVIRONMENT ||
    (hostname === PRODUCTION_HOSTNAME ? "production" : "staging");

  Sentry.init({
    dsn: DSN,
    environment,
    sendDefaultPii: false,
    tracesSampleRate: 0, // errors only
    // Filter non-actionable noise (browser extensions, benign loop warnings,
    // in-app browser scripts).
    ignoreErrors: IGNORE_ERRORS,
    denyUrls: DENY_URLS,
  });
}

export { Sentry };
